import { useState } from 'react'

export const MAX_RETRY = 5

export type MovementStatus = 'loading' | 'success' | 'error' | 'slow' | 'none'
export type NormalizedStatus = 'success' | 'failed' | 'processing'

export function useMovementStatusState() {
  const [status, setStatus] = useState<MovementStatus>('none')
  const [shouldCheckStatus, setShouldCheckStatus] = useState(true)
  const [retryCount, setRetryCount] = useState(0)

  function handleError() {
    setShouldCheckStatus(false)
    setStatus('error')
  }

  function handleSuccess(normalizedStatus: NormalizedStatus) {
    if (normalizedStatus === 'success') {
      setShouldCheckStatus(false)
      setStatus('success')
      return
    }

    if (normalizedStatus === 'failed') {
      setShouldCheckStatus(false)
      setStatus('error')
      return
    }

    if (retryCount >= MAX_RETRY) {
      setShouldCheckStatus(false)
      setStatus('slow')
      return
    }

    setRetryCount(old => old + 1)
  }

  function reset() {
    setShouldCheckStatus(true)
    setRetryCount(0)
    setStatus('none')
  }

  return {
    status,
    setStatus,
    shouldCheckStatus,
    handleError,
    handleSuccess,
    reset
  }
}

export function normalizeMultipleMovementStatuses(statuses: string[]): NormalizedStatus {
  if (statuses.every(s => s === 'success')) return 'success'
  if (statuses.some(s => s === 'failed')) return 'failed'
  return 'processing'
}
